import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useT } from "@/context/I18nContext";
import AuthLayout from "@/components/auth/AuthLayout";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const t = useT();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
      toast.success(t("auth.linkSent"));
    } catch (e) {
      setErr(errMsg(e, t("errors.generic")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      eyebrow={t("auth.forgot")}
      title={t("auth.forgotTitle")}
      subtitle={t("auth.forgotSub")}
      footer={
        <>
          <Link to="/login" data-testid="forgot-goto-login" className="text-sage-600 font-semibold hover:underline">
            ← {t("auth.signIn")}
          </Link>
        </>
      }
    >
      {sent ? (
        <div className="rounded-2xl bg-sage-100/60 border border-sage-200 p-6 text-ink-900" data-testid="forgot-sent">
          <div className="font-heading text-lg mb-1">{t("auth.linkSent")}</div>
          <p className="text-sm text-ink-500">{email}</p>
        </div>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4" data-testid="forgot-form">
          <div>
            <Label htmlFor="fp-email">{t("common.email")}</Label>
            <Input id="fp-email" data-testid="forgot-email" type="email" required value={email}
              onChange={(e) => setEmail(e.target.value)} className="mt-1.5 h-11 rounded-xl bg-white" />
          </div>
          {err && (
            <div className="rounded-xl bg-rust-500/10 border border-rust-500/20 text-rust-600 text-sm px-3 py-2" data-testid="forgot-error">
              {err}
            </div>
          )}
          <Button type="submit" data-testid="forgot-submit" disabled={busy}
            className="w-full h-11 rounded-full bg-sage-500 hover:bg-sage-600 text-white font-medium">
            {busy ? t("common.loading") : t("common.send")}
          </Button>
        </form>
      )}
    </AuthLayout>
  );
}
